import { ViewModel,View, ObservableArray } from "binder"
import  { ColumnVisibilityManipulatorView } from "./columnVisibilityManipulator-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ColumnViewModel } from "../column/column-viewModel";
import { ExTableViewModel } from "../exTable-viewModel";

export class ColumnVisibilityManipulatorViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.parentTable = <ExTableViewModel>parentViewModel;
        this.columns = ObservableArray.create<SingleColumn>();
        
    }
    GetDefaultView(): View <ViewModel> {
        return new ColumnVisibilityManipulatorView();
    }
    public getTypeId(): string {
        return "VM-FDDFD4E7-FA32-41E4-BD8D-A0C4470AE208"
    }

    closePopup(result: any){}
    private parentTable : ExTableViewModel;
    public set columns(v: ObservableArray<SingleColumn>) { this._columns = v; } public get columns(): ObservableArray<SingleColumn> { return this._columns;} private _columns: ObservableArray<SingleColumn>;
    columnsAreSetted():boolean{
        return this.columns.length>0;
    }
    setColumns(columns:ColumnViewModel[]){
        this.columns.update(...columns.map(x=>{
            let r = new SingleColumn(this);
            r.column = x;
            r.isVisible = true;
            return r;
        }))
    }
    confirm(){
        this.parentTable.onColumnVisibilityChanged();
    }
}

export class SingleColumn extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set column(v: ColumnViewModel) { this._column = v; } public get column(): ColumnViewModel { return this._column;} private _column: ColumnViewModel;
    public set isVisible(v: boolean) { this._isVisible = v; } public get isVisible(): boolean { return this._isVisible;} private _isVisible: boolean;
}
